module.exports = __webpack_public_path__ + "img/Japan.c76445c8.png";